
import firebase from '@/firebase'

// State object
const state = {
  categories: [],
  links: [],
}
// Mutations
const mutations = {
  setCategories(state, categories) {
    console.log(' state setCategories ')
    state.categories = categories
  },
  setLinks(state, links) {
    state.links = links
  },

}
// Getter functions
const getters = {
  orderedCategories: state => {
    return state.categories.sort((a,b)=>{ return a.index>b.index?1:-1; });
  },
  sortedCategories: state => {
    return state.categories.sort((a,b)=>{ return a.name.toLowerCase()>b.name.toLowerCase()?1:-1; });
  },
  orderedLinks: state => {
    return state.links.sort((a,b) => { return a.index>b.index?1:-1; });
  },
  sortedLinks: state => {
    return state.links.sort((a,b) => { return a.name.toLowerCase()>b.name.toLowerCase()?1:-1; });
  },
  categoryLinks: (state,getters) => (category_id) => {
    return getters.orderedLinks.filter(link=>link.category_id==category_id);
  },
}
// Actions
const actions = {

  addCategory({state,commit,rootState},{data}){
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const categoriesRef = db.collection('users').doc(rootState.user.uid).collection('categories');

    state.categories.push(data);

    return categoriesRef.doc(data.id).set(data).then(()=>{
      console.log("addCategory OK");
      this.dispatch('queryCategories');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },


  queryCategories({state,commit,rootState}) {
    console.log('queryCategories')
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const categoriesRef = db.collection('users').doc(rootState.user.uid).collection('categories');
    return categoriesRef.get().then(snapshot => {
      console.log('queryCategories ok')
      let arr = [];
      var index = 1;
      snapshot.forEach(register => {
        let category = { id:register.id, ...register.data() };
        if(category.column>this.getters.preferences.columnCount) category.column = 1;
        if(!category.index) category.index = index++;
        if(!category.theme) category.theme = '';
        arr.push(category);
      });
      commit('setCategories',arr);
    });
  },
  updateCategory({state,commit,rootState},{category_id,data}){
    console.log(category_id,'category_id')
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const categoriesRef = db.collection('users').doc(rootState.user.uid).collection('categories');

    state.categories.forEach(category=>{
      if(category.id == category_id) {
        for (let field in data){
          category[field] = data[field];
        }
      }
      return category;
    });

    return categoriesRef.doc(category_id).update(data).then(()=>{
      console.log("updateCategory OK");
      //this.dispatch('queryCategories');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

  deleteCategory({state,commit,rootState},{category_id}){

    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const categoriesRef = db.collection('users').doc(rootState.user.uid).collection('categories');

    var indexDelete = null;
    state.categories.forEach((category,index)=>{
      if(category.id == category_id) {
        indexDelete = index;
      }
      return category;
    });
    state.categories.splice(indexDelete,1);

    return categoriesRef.doc(category_id).delete().then(()=>{
      console.log("deleteCategory OK");
      this.dispatch('queryCategories');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },


  reorderCategories({state,commit,rootState}){
    const db = firebase.firestore();
    const categoriesRef = db.collection('users').doc(rootState.user.uid).collection('categories');
    let batch = db.batch();

    for(var col=1;col<=this.getters.preferences.columnCount;col++){
      var categories = this.getters.orderedCategories.filter(cat => cat.column?cat.column==col:col==1);
      var index=1;
      categories.forEach(cat => {
        cat.index = index++;
        let catRef = categoriesRef.doc(cat.id);
        batch.update(catRef, {column:cat.column?cat.column:1, index:cat.index });
      });
    }

    batch.commit().then(function () {
      console.log('Salvou nova ordem');
    });

  },


  addLink({state,commit,rootState},{data}){
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const linksRef = db.collection('users').doc(rootState.user.uid).collection('links');

    state.links.push(data);

    return linksRef.add(data).then(()=>{
      console.log("addLinks OK");
      this.dispatch('queryLinks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },
  queryLinks({state,commit,rootState}) {
    console.log('queryLinks')
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const linksRef = db.collection('users').doc(rootState.user.uid).collection('links');
    return linksRef.get().then(snapshot => {
      console.log('queryLinks ok')
      let arr = [];
      var index = 1;
      snapshot.forEach(register => {
        let link = { id:register.id, ...register.data() };
        if(!link.index) link.index = index++;
        if(!link.favicon){
          link.favicon = favicon(link.url);
        }
        link.hover = link.name+"\n\n"+link.url+"\n\n"+'Clique e arraste para mover o Ícone (dentro desta caixa ou para qualquer outra caixa dinâmica).\n\nClique com o botão direito para Editar, Duplicar ou Excluir este Ícone.';
        arr.push(link);

      });
      commit('setLinks',arr);
    });
  },
  updateLink({state,commit,rootState},{link_id,data}){
    console.log('update link_id',link_id,)
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const linksRef = db.collection('users').doc(rootState.user.uid).collection('links');

    state.links.forEach(link=>{
      if(link.id == link_id) {
        for (let field in data){
          link[field] = data[field];
        }
      }
      return link;
    });

    return linksRef.doc(link_id).update(data).then(()=>{
      console.log("updateLink OK");
      //this.dispatch('queryLinks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },


  deleteLink({state,commit,rootState},{link_id}){

    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const linksRef = db.collection('users').doc(rootState.user.uid).collection('links');

    var indexDelete = null;
    state.links.forEach((link,index)=>{
      if(link.id == link_id) {
        indexDelete = index;
      }
      return link;
    });
    state.links.splice(indexDelete,1);

    return linksRef.doc(link_id).delete().then(()=>{
      console.log("deleteLink OK");
      this.dispatch('queryLinks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

  reorderLinks({state,commit,rootState},{categories}){
    const db = firebase.firestore();
    const linksRef = db.collection('users').doc(rootState.user.uid).collection('links');
    let batch = db.batch();

    var i;
    for(i in categories){
      var links = this.getters.categoryLinks(categories[i]);
      var index=1;
      links.forEach(link => {
        link.index = index++;
        let itemRef = linksRef.doc(link.id);
        batch.update(itemRef, {index:link.index });
        //todo add category
      });
    }

    batch.commit().then(function () {
      console.log('Salvou nova ordem dos links');
    });


  },



}

export default {
  //namespaced: true,
  state,
  mutations,
  getters,
  actions,
}